<div wlCSCapture>
  <ng-template
    [wlGenericRichText]="field"
    [navigationExtras]="navigationExtras"
  >
    <ng-content></ng-content>
  </ng-template>
</div>
